import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

import "./GeneratingSuggestedFiltersLoader.scss";

export default function GeneratingSuggestedFiltersLoader() {
  const isGeneratingSuggestedFilters = useSelector(
    (state: RootState) => state.projectReducer.isGeneratingSuggestedFilters,
  );

  if (!isGeneratingSuggestedFilters) {
    return null;
  }

  return (
    <div className="generating-suggested-filters-loader">
      <IDHFormattedMessage
        id="ws_generating_suggestions"
        defaultMessage="Generating suggestions"
      />{" "}
      <span className="generating-suggested-filters-loader__dots">
        <span className="generating-suggested-filters-loader__dot">.</span>
        <span className="generating-suggested-filters-loader__dot">.</span>
        <span className="generating-suggested-filters-loader__dot">.</span>
      </span>
    </div>
  );
}
